import { Instance } from 'mobx-state-tree';
import { OrganizationBrandingDtoModelBase } from './OrganizationBrandingDtoModel.base';

/* The TypeScript type of an instance of OrganizationBrandingDtoModel */
export interface OrganizationBrandingDtoModelType extends Instance<typeof OrganizationBrandingDtoModel.Type> {}

/* A graphql query fragment builders for OrganizationBrandingDtoModel */
export { selectFromOrganizationBrandingDto, organizationBrandingDtoModelPrimitives, OrganizationBrandingDtoModelSelector } from './OrganizationBrandingDtoModel.base';

/**
 * OrganizationBrandingDtoModel
 */
export const OrganizationBrandingDtoModel = OrganizationBrandingDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
